import { toastNotifyError } from '@/components/Common/Toast';

export function validateEmailError(mail) {
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
    toastNotifyError('Invalid Email Id');
    return false;
  }
  return true;
}
